module.exports = __webpack_public_path__ + "static/img/十大年节@2x.c1726a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/十大年节@2x.png
// module id = ZPoJ
// module chunks = 1